<template>
  <div>
    <!-- Start Header Area -->
    <Header>
      <img slot="logo" :src="logo" />
    </Header>
    <!-- End Header Area -->

    <!-- Start Breadcrump Area  -->
    <div
      class="breadcrumb-area rn-bg-color ptb--120 bg_image bg_image--35"
      data-black-overlay="6"
    >
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="breadcrumb-inner pt--100 pt_sm--40 pt_md--50">
              <h2 class="heading-title">About</h2>
              <ul class="page-list">
                <li v-for="(item, i) in breadcrumbs" :key="i">
                  <router-link :to="item.to" :disabled="item.disabled">{{
                    item.text
                  }}</router-link>
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <!-- Start About Area  -->
    <div class="about-area ptb--120 bg_color--1">
      <div class="about-wrapper">
        <About>
          <img
            slot="thum-img"
            class="w-100"
            src="../assets/images/about/id-removebg.png"
            alt="About Images"
          />
        </About>
      </div>
    </div>
    <!-- End About Area  -->

    <!-- Start Counterup Area  -->
    <!-- <div class="rn-counterup-area ptb--120 bg_color--5">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="text-center section-title">
              <span class="subtitle">Our Journey</span>
              <h2 class="heading-title">Company Growth</h2>
              <p class="description">
                Founded by Roldhan Arana Dasalla, R.A.D Software Development Services brings over 9 years of expertise in web and mobile development.
              </p>
            </div>
          </v-col>
        </v-row>
        <CounterOne />
      </v-container>
    </div> -->
    <!-- End Counterup Area  -->

    <!-- Start Finding us Area  -->
    <!-- <div
      class="rn-finding-us-area attacment-fixed rn-finding-us ptb--120 bg_color--1 bg_image bg_image--18"
      data-black-overlay="5"
    >
      <v-container>
        <v-row>
          <v-col lg="8" offset-lg="2">
            <div class="inner">
              <div class="content-wrapper">
                <div class="text-center content">
                  <h4 class="theme-gradient">Let's Build Something Amazing</h4>
                  <p>
                    With our expertise in Laravel and Vue.js, we create robust, scalable, and innovative solutions that drive business growth. Let's transform your ideas into reality.
                  </p>
                  <router-link class="btn-default" to="/contact"
                    >Start Your Project</router-link
                  >
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div> -->
    <!-- End Finding us Area  -->

    <!-- Start team Area  -->
    <!-- <div class="rn-team-area bg_color--1 ptb--120">
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="text-center section-title mb--25">
              <span class="subtitle">Our Expertise</span>
              <h2 class="heading-title">Meet Our Team</h2>
              <p class="description">
                Led by Roldhan Arana Dasalla, our team combines years of experience
                <br />
                in Laravel and Vue.js development to deliver exceptional results.
              </p>
            </div>
          </v-col>
        </v-row>
        <TeamThree />
      </v-container>
    </div> -->
    <!-- End team Area  -->

    <!-- Start Testimonial Area  -->
    <!-- <div class="rn-testimonial-area bg_color--5 ptb--120">
      <v-container>
        <Testimonial />
      </v-container>
    </div> -->
    <!-- End Testimonial Area  -->

    <!-- Start Brand Area -->
    <!-- <div class="rn-brand-area bg_color--1 ptb--120">
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="text-center section-title mb--30">
              <span class="subtitle">Our Clients</span>
              <h2 class="heading-title">Trusted by Industry Leaders</h2>
            </div>
          </v-col>
        </v-row>
        <Brand />
      </v-container>
    </div> -->
    <!-- End Brand Area -->
    <Footer />
  </div>
</template>

<script>
  import Header from "../components/header/Header";
  import About from "../components/about/About";
  import CounterOne from "../components/counter/CounterOne";
  import TeamThree from "../components/team/TeamThree";
  import Testimonial from "../components/testimonial/Testimonial";
  import Brand from "../components/brand/Brand";
  import Footer from "../components/footer/Footer";
  export default {
    components: {
      Header,
      About,
      CounterOne,
      TeamThree,
      Testimonial,
      Brand,
      Footer,
    },
    data() {
      return {
        logo: require("../assets/images/logo/logo-ko.png"),
        breadcrumbs: [
          {
            text: "Home",
            to: "/",
            disabled: false,
          },
          {
            text: "About",
            to: "",
            disabled: true,
          },
        ],
      };
    },
  };
</script>
